import { useEffect, useState } from "react";
import EulaAction from "./EULAAction";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const EulaActionBox = () => {
    const [eulaActionDefault, setEulaActionDefault] = useState(null);

    useEffect(() => {
        const initializeEulaActionBox = async () => {
            try {
                const customEulaActionBox = await import(
                    "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/users/EULAActionBox");

                setEulaActionDefault(customEulaActionBox.default());
            } catch {
                setEulaActionDefault(<EulaAction />);
            }
        };
        initializeEulaActionBox();
    }, []);

    return <div>{eulaActionDefault}</div>;
};
export default EulaActionBox;